// extracted by mini-css-extract-plugin
export default {"page":"dh-z","cartModal":"eh-z","checkout":"fh-z","placeholder":"gh-z","account":"hh-z"};